import { createTheme } from '@mui/material';
import { createButtonStyles } from './components/buttonStyles';
import { createPaperStyles, createCardStyles } from './components/paperStyles';
import { 
  createOutlinedInputStyles, 
  createInputLabelStyles, 
  createFormHelperTextStyles 
} from './components/formStyles';

const baseTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      light: '#e3f2fd',
      dark: '#42a5f5',
    },
    secondary: {
      main: '#f48fb1',
      light: '#f8bbd0',
      dark: '#c2185b',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

const darkTheme = createTheme({
  ...baseTheme,
  components: {
    MuiButton: createButtonStyles(baseTheme),
    MuiCard: createCardStyles(baseTheme),
    MuiPaper: createPaperStyles(baseTheme),
    MuiOutlinedInput: createOutlinedInputStyles(baseTheme),
    MuiInputLabel: createInputLabelStyles(baseTheme),
    MuiFormHelperText: createFormHelperTextStyles(baseTheme),
  },
});

export default darkTheme; 